export default function capitalizeString(string = '') {
  return string && string[0].toUpperCase() + string.substring(1);
}
